import memoize from 'lodash/memoize';

export const removeDiacritics = (string: string) =>
  string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

export const stringToHue = memoize((text: string) => {
  // Prime numbers help in achieving better distribution
  const PRIME1 = 31;
  const PRIME2 = 17;

  // Convert text to an array of bytes and add some "noise"
  let hash = 0;
  const bytes = new TextEncoder().encode(text);

  for (let i = 0; i < bytes.length; i++) {
    // Add position-dependent randomization
    const rotation = (i % 8) + 1;
    const byte = bytes[i];

    // Multiple mixing steps
    hash = hash * PRIME1 + byte;
    hash = (hash << rotation) | (hash >>> (32 - rotation));
    hash = (hash * PRIME2) ^ (hash >>> 16);
    hash = Math.imul(hash, PRIME1);
  }

  // Additional mixing
  hash ^= hash >>> 15;
  hash = Math.imul(hash, PRIME2);
  hash ^= hash >>> 13;
  hash = Math.imul(hash, PRIME1);
  hash ^= hash >>> 16;

  // Make positive and map to 0-360
  hash = Math.abs(hash);
  return Math.max(1, Math.round((hash % 17) * 21.17) % 360);
});

export const matches = (query: string, target: string) => {
  const queryTerms = query.split(/\s+/).filter(Boolean).map(removeDiacritics);
  const normalizedTarget = removeDiacritics(target.toLowerCase());

  return queryTerms.every((term) => normalizedTarget.includes(term));
};
